namespace $.$$ {
	$mol_style_define( $shm_ba_mention_stats_task_list, {
		width: '16rem',
		flex: { basis: '16rem', grow: 0, shrink: 0 },
		Tasks: { flexDirection: 'column', gap: 0 },
		Task_link: { width: '100%', justifyContent: 'flex-start' },
		List_head: { flex: { grow: 1 } },
		Add_foot: {
			width: '100%',
			justifyContent: 'center',
			border: {
				radius: $mol_gap.round,
			},
			padding: $mol_gap.text,
		},
	} )
}
